module.exports = __webpack_public_path__ + "static/media/97d59ee2-387c-4d84-aab7-1c582cdc48d2_1.6b3b37572155f3c8e439ee9d820ac5b1.a556b2e1.jpeg";